module.exports = __webpack_public_path__ + "static/media/table-grid_fund_report.f846076f.svg";